import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';
import moment from 'moment';

class Component extends BaseComponent {
    componentWillMount() {
        const show = this.props.shown || this.props.hide_policy_consent ? false : true;

        this.setState({ show: show });
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.ppc != nextProps.ppc){
            this.setState({ show: false });
        }
    }

    render({ logged_in, ppc }) {
        if (this.state.show) {
            this.props.trackEvent([
                'Policy Consent',
                `${logged_in ? 'LI' : 'LO'} Impression`,
            ]);


            if (ppc) {
                this.props.setCookie({
                    name: 'POLICY_CONSENT_SHOWN',
                    value: 1,
                });
            }

            return (
                <policy-consent>
                    <div class='policy-consent-content'>
                        <p>
                            We use cookies to improve your browsing experience, analyze our traffic, and offer
                            personalized content and advertising. By continuing to use this site, you agree to the usage
                            of cookies as outlined <a href='/cookie-policy' target='_blank'>here</a>, as well as our
                            updated <a href='/privacy-policy' target='_blank'>Privacy Policy</a> and&nbsp;
                            <a href='/terms-of-use' target='_blank'>Terms of Use</a>.
                        </p>
                        <a class='close' onClick={this.decline}>×</a>
                        <a class='button' onClick={this.accept}>I ACCEPT</a>
                    </div>
                </policy-consent>
            );
        }

        return null;
    }

    accept = () => {
        this.props.trackEvent([
            'Policy Consent',
            `${this.props.logged_in ? 'LI' : 'LO'} Click`,
            'Accept',
        ]);

        this.props.updateMemberPrivacyPolicy();

        this.props.setCookie({
            name: 'PRIVACY_POLICY_CONSENT',
            value: 1,
        });

        this.props.setCookie({
            name: 'POLICY_CONSENT_SHOWN',
            value: 1,
        });

        this.setState({ show: false });
    }

    decline = () => {
        this.props.trackEvent([
            'Policy Consent',
            `${this.props.logged_in ? 'LI' : 'LO'} Click`,
            'Decline/Close',
        ]);

        this.props.setCookie({
            name: 'POLICY_CONSENT_SHOWN',
            value: 1,
            opts: {
                expires: moment().add(24, 'hours').toDate(),
            },
        });

        this.setState({ show: false });
    }
}

const mapStateToProps = (state) => ({
    ppc: state.cookie && state.cookie.PRIVACY_POLICY_CONSENT,
    logged_in: state.user && state.user.logged_in,
    shown: state.cookie && state.cookie.POLICY_CONSENT_SHOWN,
    hide_policy_consent: state.hide_policy_consent,
});

const mapDispatchToProps = (dispatch) => ({
    trackEvent: (payload) => dispatch({
        type: 'ga:event',
        payload: payload,
    }),
    setCookie: (payload) => dispatch({
        type: 'cookie:set',
        payload: payload,
    }),
    updateMemberPrivacyPolicy: () => dispatch({
        type: 'member:privacy-policy-consent',
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);



// WEBPACK FOOTER //
// ./app/components/policy-consent.js